module.exports = __webpack_public_path__ + "img/panel.49736913.png";